import { Trash2, X } from 'lucide-react';
import { useI18n } from '../../contexts/I18nContext';

interface BulkDeleteBarProps {
  count: number;
  onDelete: () => void;
  onClear: () => void;
  error?: string | null;
}

/**
 * Generic floating toolbar for row selection on directory list pages
 * (Suppliers / Clients / Subscriptions). Simplified clone of
 * LeadBulkActionsBar: shows the selection count, a delete action (the page
 * owns the confirmation dialog) and a clear-selection button.
 */
export function BulkDeleteBar({ count, onDelete, onClear, error }: BulkDeleteBarProps) {
  const { t } = useI18n();

  if (count === 0) return null;

  return (
    <div className="fixed inset-x-0 bottom-4 z-30 mx-auto flex w-full max-w-xl flex-wrap items-center gap-2 rounded-lg border border-gray-200 bg-white p-3 shadow-lg sm:px-4">
      <span className="text-sm font-medium text-gray-700">{t('bulk.selected', { count })}</span>

      <button
        type="button"
        onClick={onDelete}
        className="inline-flex items-center gap-1 rounded bg-red-50 px-2 py-1.5 text-sm text-red-700 hover:bg-red-100"
      >
        <Trash2 size={14} /> {t('bulk.delete')}
      </button>

      <button
        type="button"
        onClick={onClear}
        className="ml-auto inline-flex items-center gap-1 rounded px-2 py-1.5 text-sm text-gray-500 hover:bg-gray-100"
      >
        <X size={14} /> {t('bulk.clear')}
      </button>

      {error && <p className="w-full text-xs text-red-600">{error}</p>}
    </div>
  );
}
